// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Autocomplete, TextField, Typography } from "@mui/material";
import Icon from "@mui/material/Icon";
import MyModal from "components/Modal";
import MDTableCell from "@mui/material/TableCell";
import MDTableRow from "@mui/material/TableRow";
import MDTableHead from "@mui/material/TableHead";
import MDTableBody from "@mui/material/TableBody";
import MDTable from "@mui/material/Table";
import Swal from "sweetalert2";
import axios from "axios";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import BASE_URL from "config/Base_URL";

// Data
import authorsTableData from "layouts/tables/data/authorsTableData";
import projectsTableData from "layouts/tables/data/projectsTableData";
import { useState, useEffect, useRef, useMemo } from "react";
import MDInput from "components/MDInput";

function Tables() {
  const token = sessionStorage.getItem("token");
  const [modalShow, setModalShow] = useState(false);
  const [modalShowSales, setModalShowSales] = useState(false);

  // getProduct
  const [products, setProducts] = useState([]);

  // postPurchase
  const [namePurchase, setNamePurchase] = useState("");
  const [datePurchase, setDatePurchase] = useState("");
  const [totalPayment, setTotalPayment] = useState("");
  const [note, setNote] = useState("");
  const [item, setItem] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [customProduct, setCustomProduct] = useState({
    name: "",
    price: "",
    unit: "",
    quantity: 1,
  });

  // search Purchase
  const [filterPurchase, setFilterPurchase] = useState(null);
  const [pembelian, setPembelianParent] = useState([]);
  const { columns, rows, inputDate, snackbarComponent, modalDelete, modalDetail, modalPayment } =
    authorsTableData({ filterPurchase, setPembelianParent });

  // search Sales
  const [filterSales, setFilterSales] = useState(null);
  const [penjualan, setPenjualanParent] = useState([]);
  const {
    columnsSales,
    rowsSales,
    inputDateSales,
    snackbarComponentSales,
    modalDeleteSales,
    modalDetailSales,
    modalPaymentSales,
    modalUpdateSales,
  } = projectsTableData({ filterSales, setPenjualanParent, products });

  // postSales
  const [dateSales, setDateSales] = useState("");
  const [deliveryDate, setDeliveryDate] = useState("");
  const [deliveryStatus, setDeliveryStatus] = useState("");
  const [totalPaymentSales, setTotalPaymentSales] = useState("");
  const [noteSales, setNoteSales] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [customProductPurchase, setCustomProductPurchase] = useState({
    name: "",
    price: "",
    unit: "",
    quantity: 1,
  });

  // const [itemSales, setItemSales] = useState([]);

  const formatRupiah = (angka) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(angka);
  };

  const formRef = useRef();
  const [formSubmitted, setFormSubmitted] = useState(false);
  const formRefPurchase = useRef();
  const [formSubmittedPurchase, setFormSubmittedPurchase] = useState(false);

  // ===============================================================
  //                            GET USERNAME
  // ===============================================================

  const getUser = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const filteredUsers = response.data.data.filter(
        (user) => user.name.toLowerCase() !== "admin" && user.name.toLowerCase() !== "superadmin"
      );

      setSelectedUsers(filteredUsers);
    } catch (error) {
      console.log(error);
    }
  };

  // ========================================================
  //                        GET PRODUK
  // ========================================================
  const fetchProducts = async () => {
    try {
      const response = await fetch(`${BASE_URL}/products`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      if (data.data) {
        setProducts(data.data);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  // =========================================================
  //                        SEARCH PEMBELIAN
  // =========================================================
  const uniqueSupplier = useMemo(() => {
    const seen = new Map();
    pembelian.forEach((item) => {
      if (!seen.has(item.name)) {
        seen.set(item.name, { name: item.name });
      }
    });
    return Array.from(seen.values());
  }, [pembelian]);

  // ========================================================
  //                        POST PEMBELIAN
  // ========================================================

  const resetFormPurchase = () => {
    setNamePurchase("");
    setDatePurchase("");
    setTotalPayment("");
    setNote("");
    setItem("");
  };

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Bulan dimulai dari 0
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Untuk produk dari Autocomplete dan produk manual
  const handleAddProduct = () => {
    // Cek jika produk dari Autocomplete
    if (selectedProduct) {
      const existingProductIndex = selectedProducts.findIndex((p) => p.id === selectedProduct.id);

      if (existingProductIndex >= 0) {
        // Jika produk sudah ada, tambahkan jumlahnya
        const updatedProducts = [...selectedProducts];
        updatedProducts[existingProductIndex].quantity += 1;
        updatedProducts[existingProductIndex].subtotal =
          updatedProducts[existingProductIndex].price *
          updatedProducts[existingProductIndex].quantity;
        setSelectedProducts(updatedProducts);
      } else {
        // Tambahkan produk baru dari Autocomplete
        setSelectedProducts([
          ...selectedProducts,
          {
            id: selectedProduct.id,
            name: `${selectedProduct.name.toUpperCase()} - ${
              selectedProduct.unit?.toUpperCase() || "KG"
            }`,
            price: selectedProduct.price,
            unit: selectedProduct.unit?.toUpperCase() || "KG",
            quantity: 1,
            subtotal: selectedProduct.price,
          },
        ]);
      }
      setSelectedProduct(null);
    }

    // Cek jika ada input manual
    if (customProduct.name && customProduct.price) {
      const newId = `custom-${Date.now()}`;
      setSelectedProducts([
        ...selectedProducts,
        {
          id: newId,
          name: `${customProduct.name.toUpperCase()} - ${
            customProduct.unit?.toUpperCase() || "PCS"
          }`,
          price: parseFloat(customProduct.price) || 0,
          unit: customProduct.unit?.toUpperCase() || "PCS",
          quantity: customProduct.quantity,
          subtotal: (parseFloat(customProduct.price) || 0) * customProduct.quantity,
        },
      ]);
      // Reset field input manual
      setCustomProduct({ name: "", price: "", unit: "", quantity: 1 });
    }
  };

  // Perubahan jumlah kuantitas
  const handleQuantityChange = (id, newQuantity) => {
    const updatedProducts = selectedProducts.map((product) => {
      if (product.id === id) {
        return {
          ...product,
          quantity: newQuantity,
          subtotal: product.price * newQuantity,
        };
      }
      return product;
    });
    setSelectedProducts(updatedProducts);
  };

  // Hapus produk dari list
  const handleRemoveProduct = (id) => {
    setSelectedProducts(selectedProducts.filter((p) => p.id !== id));
  };

  // Hitung total
  const calculateTotal = () => {
    return selectedProducts.reduce((sum, product) => sum + product.subtotal, 0);
  };

  const handleAddPurchase = async () => {
    try {
      // Prepare purchase items data
      const purchaseItems = selectedProducts.map((product) => ({
        id: 0,
        price: product.price,
        unit: product.unit || "KG",
        amount: product.quantity,
        name: product.name,
      }));

      // Prepare the request body
      const requestBody = {
        name: namePurchase,
        dateOfPurchase: datePurchase,
        totalPayment: totalPayment || 0,
        note: note || "-",
        purchaseItems: purchaseItems,
      };

      console.log("REQUEST", requestBody);

      // Make the API call
      const response = await fetch(`${BASE_URL}/add/purchase`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      // Reset form and close modal
      resetFormPurchase();
      setSelectedProducts([]);
      setModalShow(false);
      Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: "Pembelian berhasil ditambahkan",
      });
      fetchProducts();
    } catch (error) {
      setModalShow(false);
      Swal.fire({
        icon: "error",
        title: "Gagal",
        text: "Pembelian gagal ditambahkan",
      });
    }
  };

  const renderFormPostPurchase = (
    <MDBox
      component="form"
      role="form"
      sx={{ width: "70vw" }}
      ref={formRefPurchase}
      onSubmit={(e) => {
        e.preventDefault();
        if (!selectedProduct && selectedProducts.length === 0) {
          setModalShow(false);
          Swal.fire({
            icon: "warning",
            title: "Data Belum Lengkap",
            text: "Pastikan semua inputan wajib termasuk dropdown diisi.",
          });
          return;
        }
        setFormSubmittedPurchase(true);
      }}
    >
      <MDBox mb={2}>
        <MDInput
          type="text"
          label="Nama Supplier"
          fullWidth
          required
          value={namePurchase}
          onChange={(e) => setNamePurchase(e.target.value.toUpperCase())}
        />
      </MDBox>
      <MDBox mb={2}>
        <MDInput
          type="date"
          label="Tanggal Pembelian"
          fullWidth
          disabled
          value={datePurchase}
          onChange={(e) => setDatePurchase(e.target.value)}
        />
      </MDBox>
      <MDBox mb={2}>
        <MDInput
          label="Catatan"
          fullWidth
          required
          value={note}
          onChange={(e) => setNote(e.target.value)}
          InputLabelProps={{ shrink: true }}
          multiline
          inputProps={{ maxLength: 250 }}
          rows={2}
          sx={{
            "& .MuiOutlinedInput-root": {
              alignItems: "flex-start",
            },
            "& textarea": {
              resize: "vertical",
              minHeight: "80px",
            },
          }}
        />
        <Typography variant="caption" color="textSecondary">
          Maksimal 250 karakter • {note.length}/250
        </Typography>
      </MDBox>
      <MDBox mb={2}>
        <MDTypography variant="h6">Produk Lainnya (Jika tidak tersedia di daftar)</MDTypography>

        <TextField
          label="Nama Produk"
          fullWidth
          sx={{ mb: 1 }}
          value={customProductPurchase.name}
          onChange={(e) =>
            setCustomProductPurchase({
              ...customProductPurchase,
              name: e.target.value.toUpperCase(),
            })
          }
        />
        <TextField
          label="Harga Produk"
          fullWidth
          type="text"
          sx={{ mb: 1 }}
          value={formatRupiah(customProductPurchase.price)}
          onChange={(e) => {
            const onlyNums = e.target.value.replace(/[^0-9]/g, "");
            setCustomProductPurchase({ ...customProductPurchase, price: onlyNums });
          }}
        />
        <TextField
          label="Unit"
          fullWidth
          sx={{ mb: 1 }}
          value={customProductPurchase.unit}
          onChange={(e) =>
            setCustomProductPurchase({
              ...customProductPurchase,
              unit: e.target.value.toUpperCase(),
            })
          }
        />

        <TextField
          label="Jumlah"
          type="text"
          fullWidth
          sx={{ mb: 1 }}
          inputProps={{
            inputMode: "decimal", // tampilkan keyboard desimal di mobile
          }}
          value={customProductPurchase.quantity}
          onChange={(e) => {
            let value = e.target.value;

            // Izinkan angka dengan koma/titik dan maksimal 2 desimal
            if (/^\d*[.,]?\d{0,2}$/.test(value) || value === "") {
              // Ganti koma ke titik untuk konsistensi
              value = value.replace(",", ".");
              setCustomProductPurchase((prev) => ({
                ...prev,
                quantity: value, // simpan string mentah dulu
              }));
            }
          }}
          onBlur={(e) => {
            let value = e.target.value.replace(",", ".");
            let floatValue = parseFloat(value);

            // Jika kosong atau bukan angka → jadikan 0
            if (isNaN(floatValue)) floatValue = 0;

            // Bulatkan ke dua desimal
            floatValue = parseFloat(floatValue.toFixed(2));

            setCustomProductPurchase((prev) => ({
              ...prev,
              quantity: floatValue, // simpan sebagai number float
            }));
          }}
        />

        <MDButton
          variant="outlined"
          color="info"
          fullWidth
          onClick={() => {
            if (customProductPurchase.name && customProductPurchase.price) {
              const newProduct = {
                id: `custom-${Date.now()}`,
                name: customProductPurchase.name,
                price: parseFloat(customProductPurchase.price),
                unit: customProductPurchase.unit,
                quantity: customProductPurchase.quantity,
                subtotal: parseFloat(customProductPurchase.price) * customProductPurchase.quantity,
              };
              setSelectedProducts((prev) => [...prev, newProduct]);
              setCustomProductPurchase({ name: "", price: "", unit: "", quantity: 1 }); // Reset form
            } else {
              setModalShowSales(false);
              Swal.fire("Perhatian", "Silakan lengkapi Nama dan Harga produk lainnya", "warning");
            }
          }}
        >
          <Icon>add</Icon>&nbsp;Tambah Produk Lainnya
        </MDButton>
      </MDBox>

      {/* Selected Products Table */}
      {selectedProducts.length > 0 && (
        <MDBox mt={4}>
          <MDTypography variant="h6">Daftar Produk Dipilih</MDTypography>
          <MDTable>
            <MDTableBody>
              <MDTableRow>
                {/* Header Kolom */}
                <MDTableCell
                  sx={{
                    textAlign: "left",
                    width: "35%",
                    fontWeight: "bold",
                  }}
                >
                  Nama Produk
                </MDTableCell>

                <MDTableCell
                  sx={{
                    textAlign: "right",
                    width: "20%",
                    fontWeight: "bold",
                  }}
                >
                  Harga
                </MDTableCell>
                <MDTableCell
                  sx={{
                    textAlign: "right",
                    fontWeight: "bold",
                  }}
                >
                  Unit
                </MDTableCell>

                <MDTableCell
                  sx={{
                    textAlign: "center",
                    width: "20%",
                    fontWeight: "bold",
                  }}
                >
                  Jumlah
                </MDTableCell>

                <MDTableCell
                  sx={{
                    textAlign: "right",
                    width: "20%",
                    fontWeight: "bold",
                  }}
                >
                  Subtotal
                </MDTableCell>

                <MDTableCell
                  sx={{
                    textAlign: "center",
                    width: "10%",
                    fontWeight: "bold",
                  }}
                >
                  Aksi
                </MDTableCell>
              </MDTableRow>

              {selectedProducts.map((product) => (
                <MDTableRow key={product.id}>
                  {/* Isi Tabel */}
                  <MDTableCell
                    sx={{
                      textAlign: "left",
                      width: "25%",
                    }}
                  >
                    {product.name}
                  </MDTableCell>

                  <MDTableCell
                    sx={{
                      textAlign: "right",
                      width: "20%",
                    }}
                  >
                    Rp {product.price.toLocaleString()}
                  </MDTableCell>
                  <MDTableCell sx={{ textAlign: "center" }}>{product.unit}</MDTableCell>
                  <MDTableCell
                    sx={{
                      textAlign: "center",
                      width: "15%",
                    }}
                  >
                    <TextField
                      label="Jumlah"
                      type="text"
                      fullWidth
                      sx={{
                        width: "100%",
                        maxWidth: "80px",
                        mb: 1,
                        "& .MuiInputBase-root": { height: "40px" },
                      }}
                      inputProps={{
                        inputMode: "decimal",
                        style: { textAlign: "center" },
                      }}
                      value={product.quantity?.toString() ?? ""}
                      onChange={(e) => {
                        let value = e.target.value;

                        // izinkan angka dengan koma/titik dan maksimal 2 angka desimal
                        if (/^\d*[.,]?\d{0,2}$/.test(value) || value === "") {
                          // ganti koma ke titik biar konsisten
                          handleQuantityChange(product.id, value.replace(",", "."));
                        }
                      }}
                      onBlur={(e) => {
                        let value = e.target.value.replace(",", ".");
                        let formatted = parseFloat(value);

                        // kalau kosong atau bukan angka, jadikan 0
                        if (isNaN(formatted)) formatted = 0;

                        // bulatkan ke 2 desimal
                        formatted = parseFloat(formatted.toFixed(2));

                        handleQuantityChange(product.id, formatted);
                      }}
                    />
                  </MDTableCell>

                  <MDTableCell
                    sx={{
                      textAlign: "right",
                      width: "20%",
                    }}
                  >
                    Rp {product.subtotal.toLocaleString()}
                  </MDTableCell>

                  <MDTableCell
                    sx={{
                      textAlign: "center",
                      width: "20%",
                    }}
                  >
                    <MDButton
                      color="error"
                      onClick={() => handleRemoveProduct(product.id)}
                      sx={{
                        minWidth: "40px",
                        width: "40px",
                        height: "40px",
                        padding: 0,
                      }}
                    >
                      <Icon sx={{ fontWeight: "bold" }}>remove</Icon>
                    </MDButton>
                  </MDTableCell>
                </MDTableRow>
              ))}

              {/* Baris Total */}
              <MDTableRow>
                <MDTableCell
                  colSpan={4}
                  sx={{
                    textAlign: "right",
                    fontWeight: "bold",
                  }}
                >
                  Total:
                </MDTableCell>

                <MDTableCell
                  sx={{
                    textAlign: "right",
                    fontWeight: "bold",
                  }}
                >
                  Rp {calculateTotal().toLocaleString()}
                </MDTableCell>

                <MDTableCell></MDTableCell>
              </MDTableRow>
            </MDTableBody>
          </MDTable>
        </MDBox>
      )}
      <MDBox mb={2}>
        <MDInput
          type="text"
          label="Total Pembayaran"
          fullWidth
          required
          value={formatRupiah(totalPayment)}
          onChange={(e) => {
            const onlyNums = e.target.value.replace(/[^0-9]/g, "");
            setTotalPayment(onlyNums);
          }}
        />
      </MDBox>
    </MDBox>
  );

  // ===========================================================
  //                            POST SALES
  // ===========================================================

  const handleAddSales = async () => {
    try {
      const salesItems = selectedProducts.map((product) => ({
        name: product.name,
        id: product.id ? parseInt(product.id) : 0,
        price: product.price,
        unit: product.unit,
        amount: product.quantity,
      }));

      const requestBody = {
        businessName: selectedUser?.businessName,
        date: dateSales,
        deliveryDate: deliveryDate,
        deliveryStatus: deliveryStatus,
        totalPayment: parseFloat(totalPaymentSales) || 0,
        note: noteSales || "-",
        items: salesItems,
      };

      console.log("Request Body:", JSON.stringify(requestBody, null, 2));

      const response = await fetch(`${BASE_URL}/add/sales`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const responseData = await response.json();
      console.log("Response Data:", responseData);

      if (!response.ok) {
        setModalShowSales(false);
        throw new Error(responseData.message || "Gagal menambahkan penjualan.");
      }

      setModalShowSales(false);
      Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: "Berhasil menambahkan penjualan",
      });
    } catch (error) {
      setModalShowSales(false);
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal",
        text: error.message || "Terjadi kesalahan saat menambahkan penjualan",
      });
    }
  };

  const statusOptions = ["SELESAI", "PENGIRIMAN", "GAGAL"];

  const renderFormPostSales = (
    <MDBox
      ref={formRef}
      component="form"
      role="form"
      onSubmit={(e) => {
        e.preventDefault();
        if (
          !selectedUser ||
          !deliveryStatus ||
          (!selectedProduct && selectedProducts.length === 0)
        ) {
          setModalShowSales(false);
          Swal.fire({
            icon: "warning",
            title: "Data Belum Lengkap",
            text: "Pastikan semua inputan wajib termasuk dropdown diisi.",
          });
          return;
        }
        setFormSubmitted(true);
      }}
      sx={{ width: "70vw" }}
    >
      <MDBox mb={2}>
        <Autocomplete
          options={selectedUsers}
          getOptionLabel={(option) => `${option.name} - ${option.businessName}`}
          value={selectedUser}
          onChange={(event, newValue) => setSelectedUser(newValue)}
          renderInput={(params) => (
            <TextField {...params} label="Pilih Restoran Pembeli" variant="outlined" />
          )}
        />
      </MDBox>
      <MDBox mb={2}>
        <MDInput
          required
          type="date"
          label="Tanggal Penjualan"
          fullWidth
          // disabled
          value={dateSales}
          onChange={(e) => setDateSales(e.target.value)}
        />
      </MDBox>
      <MDBox mb={2}>
        <MDInput
          type="date"
          required
          label="Tanggal Pengantaran"
          fullWidth
          value={deliveryDate}
          onChange={(e) => setDeliveryDate(e.target.value)}
        />
      </MDBox>
      <MDBox mb={2}>
        <Autocomplete
          disablePortal
          options={statusOptions}
          value={deliveryStatus}
          onChange={(event, newValue) => {
            setDeliveryStatus(newValue);
          }}
          fullWidth
          renderInput={(params) => <TextField {...params} label="Status" />}
        />
      </MDBox>
      <MDBox mb={2}>
        <MDInput
          type="text"
          required
          label="Catatan"
          fullWidth
          value={noteSales}
          onChange={(e) => setNoteSales(e.target.value)}
          multiline
          inputProps={{ maxLength: 250 }}
          rows={2}
          sx={{
            "& .MuiOutlinedInput-root": {
              alignItems: "flex-start",
            },
            "& textarea": {
              resize: "vertical",
              minHeight: "80px",
            },
          }}
        />
        <Typography variant="caption" color="textSecondary">
          Maksimal 250 karakter • {noteSales.length}/250
        </Typography>
      </MDBox>
      <MDBox mb={2} style={{ display: "flex", gap: "2%" }}>
        <Autocomplete
          options={products}
          getOptionLabel={(option) => `${option.name} - ${option.unit || ""}`}
          value={selectedProduct}
          onChange={(event, newValue) => setSelectedProduct(newValue)}
          sx={{ width: "90%" }}
          renderInput={(params) => (
            <TextField {...params} label="Pilih Produk" variant="outlined" />
          )}
        />
        <MDButton
          variant="gradient"
          color="dark"
          onClick={handleAddProduct}
          disabled={!selectedProduct}
          sx={{ height: "52px" }}
        >
          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
        </MDButton>
      </MDBox>
      <MDBox mb={2}>
        <MDTypography variant="h6">Produk Lainnya (Jika tidak tersedia di daftar)</MDTypography>

        <TextField
          label="Nama Produk"
          fullWidth
          sx={{ mb: 1 }}
          value={customProduct.name}
          onChange={(e) =>
            setCustomProduct({ ...customProduct, name: e.target.value.toUpperCase() })
          }
        />
        <TextField
          label="Harga Produk"
          fullWidth
          type="text"
          sx={{ mb: 1 }}
          value={formatRupiah(customProduct.price)}
          onChange={(e) => {
            const onlyNums = e.target.value.replace(/[^0-9]/g, "");
            setCustomProduct({ ...customProduct, price: onlyNums });
          }}
        />
        <TextField
          label="Unit"
          fullWidth
          sx={{ mb: 1 }}
          value={customProduct.unit}
          onChange={(e) =>
            setCustomProduct({ ...customProduct, unit: e.target.value.toUpperCase() })
          }
        />

        <TextField
          label="Jumlah"
          type="text" // tetap text agar bisa input desimal
          fullWidth
          sx={{ mb: 1 }}
          value={customProduct.quantity?.toString() ?? ""}
          onChange={(e) => {
            let value = e.target.value;

            // izinkan angka desimal dengan koma/titik, maksimal 2 angka di belakang koma
            if (/^\d*[.,]?\d{0,2}$/.test(value) || value === "") {
              value = value.replace(",", ".");
              setCustomProduct({
                ...customProduct,
                quantity: value,
              });
            }
          }}
          onBlur={(e) => {
            let value = e.target.value.replace(",", ".");
            let formatted = parseFloat(value);

            // kalau kosong atau bukan angka, jadikan 0
            if (isNaN(formatted)) formatted = 0;

            // bulatkan ke 2 desimal
            formatted = parseFloat(formatted.toFixed(2));

            setCustomProduct({
              ...customProduct,
              quantity: formatted,
            });
          }}
        />

        <MDButton
          variant="outlined"
          color="info"
          fullWidth
          onClick={() => {
            if (customProduct.name && customProduct.price) {
              const newProduct = {
                id: `custom-${Date.now()}`,
                name: customProduct.name,
                price: parseFloat(customProduct.price),
                quantity: customProduct.quantity,
                unit: customProduct.unit,
                subtotal: parseFloat(customProduct.price) * customProduct.quantity,
              };
              setSelectedProducts((prev) => [...prev, newProduct]);
              setCustomProduct({ name: "", price: "", unit: "", quantity: 1 }); // Reset form
            } else {
              setModalShowSales(false);
              Swal.fire("Perhatian", "Silakan lengkapi Nama dan Harga produk lainnya", "warning");
            }
          }}
        >
          <Icon>add</Icon>&nbsp;Tambah Produk Lainnya
        </MDButton>
      </MDBox>

      {selectedProducts.length > 0 && (
        <MDBox mt={4}>
          <MDTypography variant="h6">Daftar Produk Dipilih</MDTypography>
          <MDTable>
            <MDTableBody>
              <MDTableRow>
                {/* Header Kolom */}
                <MDTableCell sx={{ textAlign: "left", width: "25%", fontWeight: "bold" }}>
                  Nama Produk
                </MDTableCell>

                <MDTableCell sx={{ textAlign: "right", width: "15%", fontWeight: "bold" }}>
                  Harga Satuan
                </MDTableCell>

                <MDTableCell sx={{ textAlign: "center", width: "10%", fontWeight: "bold" }}>
                  Unit
                </MDTableCell>

                <MDTableCell sx={{ textAlign: "center", width: "15%", fontWeight: "bold" }}>
                  Jumlah
                </MDTableCell>

                <MDTableCell sx={{ textAlign: "right", width: "20%", fontWeight: "bold" }}>
                  Subtotal
                </MDTableCell>

                <MDTableCell sx={{ textAlign: "center", width: "10%", fontWeight: "bold" }}>
                  Aksi
                </MDTableCell>
              </MDTableRow>

              {selectedProducts.map((product) => (
                <MDTableRow key={product.id}>
                  {/* Isi Tabel */}
                  <MDTableCell sx={{ textAlign: "left" }}>{product.name}</MDTableCell>

                  <MDTableCell sx={{ textAlign: "right" }}>
                    Rp {product.price.toLocaleString()}
                  </MDTableCell>

                  <MDTableCell sx={{ textAlign: "center" }}>{product.unit}</MDTableCell>

                  <MDTableCell sx={{ textAlign: "center" }}>
                    <TextField
                      label="Jumlah"
                      type="text"
                      fullWidth
                      sx={{
                        width: "100%",
                        maxWidth: "80px",
                        mb: 1,
                        "& .MuiInputBase-root": {
                          height: "40px",
                        },
                      }}
                      inputProps={{
                        inputMode: "decimal",
                        style: { textAlign: "center" },
                      }}
                      value={product.quantity?.toString() ?? ""}
                      onChange={(e) => {
                        let value = e.target.value;

                        // izinkan angka desimal dengan koma/titik, maksimal 2 angka di belakang koma
                        if (/^\d*[.,]?\d{0,2}$/.test(value) || value === "") {
                          value = value.replace(",", ".");
                          handleQuantityChange(product.id, value); // simpan string mentah
                        }
                      }}
                      onBlur={(e) => {
                        let value = e.target.value.replace(",", ".");
                        let formatted = parseFloat(value);

                        // kalau kosong atau bukan angka, jadikan 0
                        if (isNaN(formatted)) formatted = 0;

                        // bulatkan ke 2 desimal
                        formatted = parseFloat(formatted.toFixed(2));

                        handleQuantityChange(product.id, formatted);
                      }}
                    />
                  </MDTableCell>

                  <MDTableCell sx={{ textAlign: "right" }}>
                    Rp {product.subtotal.toLocaleString()}
                  </MDTableCell>

                  <MDTableCell sx={{ textAlign: "center" }}>
                    <MDButton
                      color="error"
                      onClick={() => handleRemoveProduct(product.id)}
                      sx={{
                        minWidth: "40px",
                        width: "40px",
                        height: "40px",
                        padding: 0,
                      }}
                    >
                      <Icon sx={{ fontWeight: "bold" }}>remove</Icon>
                    </MDButton>
                  </MDTableCell>
                </MDTableRow>
              ))}

              {/* Baris Total */}
              <MDTableRow>
                <MDTableCell colSpan={4} sx={{ textAlign: "right", fontWeight: "bold" }}>
                  Total:
                </MDTableCell>
                <MDTableCell sx={{ textAlign: "right", fontWeight: "bold" }}>
                  Rp {calculateTotal().toLocaleString()}
                </MDTableCell>
                <MDTableCell></MDTableCell>
              </MDTableRow>
            </MDTableBody>
          </MDTable>
        </MDBox>
      )}
      <MDBox mb={2}>
        <MDInput
          type="text"
          required
          label="Total Pembayaran"
          fullWidth
          value={formatRupiah(totalPaymentSales)}
          onChange={(e) => {
            const onlyNumsa = e.target.value.replace(/[^0-9]/g, "");
            setTotalPaymentSales(onlyNumsa);
          }}
        />
      </MDBox>
    </MDBox>
  );

  // =========================================================
  //                        SEARCH PENJUALAN
  // =========================================================
  const uniqueRestoran = useMemo(() => {
    const seen = new Map();
    penjualan.forEach((item) => {
      if (!seen.has(item.name)) {
        seen.set(item.name, { name: item.name });
      }
    });
    return Array.from(seen.values());
  }, [penjualan]);

  useEffect(() => {
    getUser();
    fetchProducts();
    setDatePurchase(getCurrentDate());
    setDateSales(getCurrentDate());
    if (formSubmitted) {
      handleAddSales();
      setFormSubmitted(false);
    }
    if (formSubmittedPurchase) {
      handleAddPurchase();
      setFormSubmittedPurchase(false);
    }
  }, [formSubmitted, formSubmittedPurchase]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {modalDetail}
      {modalDelete}
      {modalPayment}
      {snackbarComponent}
      {snackbarComponentSales}
      {modalDeleteSales}
      {modalDetailSales}
      {modalPaymentSales}
      {modalUpdateSales}
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Pembelian
                </MDTypography>
              </MDBox>
              <MDBox
                // display="flex"
                // flexDirection="column"
                // width="20%"
                // gap="2px"
                mx={2}
                mt={3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="transparent"
                borderRadius="lg"
              >
                <MDButton variant="gradient" color="dark" onClick={() => setModalShow(true)}>
                  <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                  &nbsp;Tambah Pembelian
                </MDButton>
                {/* <MDButton variant="gradient" color="dark" onClick={() => setModalShow(true)}>
                  <Icon sx={{ fontWeight: "bold" }}>refresh</Icon>
                  &nbsp;Refresh pembelian
                </MDButton> */}
              </MDBox>
              <MDBox pt={3} px={2}>
                {inputDate}
                &nbsp;
                <Autocomplete
                  options={uniqueSupplier}
                  getOptionLabel={(option) => `${option.name}`}
                  value={filterPurchase}
                  onChange={(event, newValue) => setFilterPurchase(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} label="Pilih Supplier" variant="outlined" />
                  )}
                />
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Penjualan
                </MDTypography>
              </MDBox>
              <MDBox
                mx={2}
                mt={3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="transparent"
                borderRadius="lg"
              >
                <MDButton variant="gradient" color="dark" onClick={() => setModalShowSales(true)}>
                  <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                  &nbsp;Tambah Penjualan
                </MDButton>
              </MDBox>
              <MDBox pt={3} px={2}>
                {inputDateSales}
                &nbsp;
                <Autocomplete
                  options={uniqueRestoran}
                  getOptionLabel={(option) => `${option.name}`}
                  value={filterSales}
                  onChange={(event, newValue) => setFilterSales(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} label="Pilih Restoran" variant="outlined" />
                  )}
                />
                <DataTable
                  table={{
                    columns: columnsSales,
                    rows: rowsSales,
                  }}
                  isSorted={false}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* modal post Sales */}
      <MyModal
        show={modalShowSales}
        onHide={() => setModalShowSales(false)}
        title="Tambah Penjualan"
        body={renderFormPostSales}
        onSubmit={() => {
          if (formRef.current) {
            formRef.current.requestSubmit();
          }
        }}
        submitText="Simpan"
        colorButtonSubmit="info"
      />

      {/* modal post Purchase */}
      <MyModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        title="Tambah Pembelian"
        body={renderFormPostPurchase}
        onSubmit={() => {
          if (formRefPurchase.current) {
            formRefPurchase.current.requestSubmit();
          }
        }}
        submitText="Simpan"
        colorButtonSubmit="info"
      />
    </DashboardLayout>
  );
}

export default Tables;
